import type { Asset } from '@/types';
import TokenItem from '@/ui/components/token-item';
import useBalance from '@/ui/hooks/use-balance';
import useFiatBalance from '@/ui/hooks/use-fiat-balance';

export interface TokenPickerOptionProps {
  asset: Asset;
  className?: string;
}

function TokenPickerOption({ asset }: TokenPickerOptionProps) {
  const { name, baseAssetName, displayName, displayTicker } = asset;

  const { value: balance } = useBalance(name);
  const { value: fiatValue } = useFiatBalance(name);

  return (
    <TokenItem
      name={name}
      displayName={displayName}
      itemName={displayName}
      displayTicker={displayTicker}
      balance={balance?.toDefaultNumber()}
      fiatValue={fiatValue?.toDefaultNumber()}
      chainName={baseAssetName}
      className="gap-x-2"
    />
  );
}

export default TokenPickerOption;
